import { useBrowseLayoutQuery } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useBrowseLayoutQuery/useBrowseLayoutQuery";
import { useIsBrowseLayoutLoading } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useBrowseLayoutQuery/useIsBrowseLayoutLoading";

export const useIsBrowseLayoutLoadedAndHasNoResults = () => {
  const { isError, data: viewLayout } = useBrowseLayoutQuery();
  const isLoading = useIsBrowseLayoutLoading();
  if (isLoading) {
    return false;
  }
  if (isError) {
    return true;
  }

  return viewLayout?.content.length === 0;
};
